import type { FC } from 'react';
import { useLngMarketingRoot } from 'src/apis/lng-marketing/use-lng-marketing-root';
import type { ActiveSection } from 'src/components/layout/header/types';
import { Link } from 'src/components/navigation/link';

export const isLngActive = (pathname: string) => pathname.startsWith('/lng');

export const SecondaryNavLng: FC<{ activeSection: ActiveSection }> = ({
  activeSection,
}) => {
  const lngMarketingRoot = useLngMarketingRoot();
  if (!activeSection.lng || !lngMarketingRoot.response) return null;

  const hasAllocations =
    lngMarketingRoot.response.data._links.getAllocationsOverviewForLso ||
    lngMarketingRoot.response.data._links.getAllocationsOverviewForShipper;

  return (
    <div
      className={`
        flex flex-col flex-wrap items-stretch gap-x-xl gap-y-md
        md:flex-row md:items-center
      `}
      data-testid="secondary-nav"
    >
      <Link mode="secondary" to="/lng/offers">
        LNG Offers
      </Link>
      {hasAllocations && (
        <Link mode="secondary" to="/lng/allocations">
          LNG Allocations
        </Link>
      )}
    </div>
  );
};
